import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from 'state/auth';

const PublicRoute = () => {
  const { user, isUserEmailVerified, isAuthenticated } = useUser();
  const location = useLocation();

  if (!isUserEmailVerified && user) {
    return <Navigate to="/email-verification" />;
  }

  if (isAuthenticated) {
    const intendedPath = location.state?.from?.pathname
      ? `${location.state.from.pathname}${location.state.from.search ?? ''}`
      : '/dashboard';

    return <Navigate to={intendedPath} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
